module.exports = __webpack_public_path__ + "img/baidi.f8071ff9.png";